import * as React from 'react';
import styled from '../../styled';
import { rotate, line } from '../../keyframes';
const Loading = styled.svg `
  > circle {
    fill: none;
    stroke: ${({ color = 'PRIMARY_600', theme }) => theme.colors[color]};
    box-sizing: border-box;
    stroke-width: 0.1875rem;
    transform-origin: 50%;
    animation: ${line} 1.6s cubic-bezier(0.4, 0, 0.2, 1) infinite,
      ${rotate} 1.6s linear infinite;
  }
`;
const LoadingSpinner = ({ color, size = 24, }) => (React.createElement(Loading, { viewBox: "0 0 32 32", width: size, height: size, color: color },
    React.createElement("circle", { cx: "16", cy: "16", r: "14" })));
export default LoadingSpinner;
//# sourceMappingURL=index.js.map